


















































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Airport from "@/store/entities/flight/airport";
import Agency from "@/store/entities/agency";
import moment from "moment";
import FlightPassenger from "@/store/entities/flight/flightPassengerList";
import ajax from "@/lib/ajax";

@Component({
  components: {
    
  },
})
export default class FlightPassengerList extends Vue {
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  active_tab: number = 0;
  checkbox: boolean = false;
  isOpenRow: boolean = false;
  radios: boolean = true;
  flightPassenger: FlightPassenger[] = [];
  filterPassengerList: FlightPassenger[] = [];
  startDate: Date = null;
  startDateMenu: boolean = false;
  endDate: Date = null;
  endDateMenu: boolean = false;
  airports: Airport[] = [];
  fromAirport: Airport = new Airport();
  toAirport: Airport = new Airport();
  agencies: Agency[] = [];
  agency:Agency=new Agency();
  customerName: string = "";
  flightNo: string = "";
  pnr: string="";
  sendMailModal: boolean = false;
  checkedPassenger: any[] = [];
  transfers:any[]=[];
  totalPax:number=0;
  customerSurname:string="";
  searchKey:string="";
  
  closeDialog(e) {
    this.sendMailModal = false;
  }
  list(e) {}
  get excel_fields (){
    // regular field (exported data 'as is')
  
     return  {
        "name":"flightNo",
        
        "pnr" : {
                field: 'flightOrders',
                callback: (value) => {
                  for (let index = 0; index < value.length; index++) {
                    return ` ${value[index].orderNo}`;
                    
                  }
                }
     }
    }
   
}
data() {
    return {
      sortBy: [{ key: 'departureDate', order: 'asc' }],
      groupBy: [{ key: 'departureDate', order: 'asc' }]
    };
  }
  clearForm(){
    this.pnr="";
    this.customerName="";
    this.customerSurname="";
    this.flightNo="";
    this.agency=null;
    this.startDate=null;
    this.endDate=null;
  }
   tableToExcel = (function() {
  var uri = 'data:application/vnd.ms-excel;base64,'
    , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
    , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
    , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
  return function(table, name) {
    if (!table.nodeType) table = document.getElementById(table)
    var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
    window.location.href = uri + base64(format(template, ctx))
  }
})()
  
  
  sendEmailInfo() {
    this.sendMailModal = true;
  }
  get getEndDate() {
    return this.endDate ? moment(this.endDate).format("DD-MM-yyyy") : "";
  }
  get getStartDate() {
    return this.startDate ? moment(this.startDate).format("DD-MM-yyyy") : "";
  }
  created() {
   

    (this.headers = [
      { text: "SiparişNo", value: "pnr" },
      { text: "Güzergah", value: "destination" },
      { text: "Kalkış Saati", value: "flightNumber" },
      { text: "Araç", value: "operator" },
      { text: "Yolcu Sayısı", value: "operatorPnr" },
      { text: "Müşteri Adı", value: "surname" },
      { text: "Telefon", value: "name" },
      { text: "Email", value: "gender" },
    ]),
      (this.breadcrumbsItems = [
        { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
        { text: "Transfer", disabled: true },
        { text: "Transfer Yolcu Listesi", disabled: true },
      ]);
  }
  async searchPassengers() {
    if(this.agency==null || this.agency==undefined){
      let agency = new Agency(); 
      this.agency=agency;
    }
    this.flightPassenger= [];
    this.totalPax=0;
    const payload = {
      customerName: this.customerName,
      customerSurname: this.customerSurname,
      flightNo:this.flightNo,
      agencyId:this.agency.id,
      orderNo:this.pnr,
      starts: moment(this.startDate).format("MM-DD-yyyy"),
      ends: moment(this.endDate).format("MM-DD-yyyy"),
    };
    const response = await ajax.get(
      "/api/services/app/transfer/GetTransferPassengers",
      { params: { ...payload } }
    );
    const data = response.data.result.items;
    this.transfers=data;
    

    // const result = this.groupBy(data, "departureDate");
   
  }

  @Watch("searchKey")
  filterPassengers() {
    if(this.filterPassengerList.length==0){
      this.filterPassengerList=this.flightPassenger;
   // let filterResults=this.flightPassenger.filter(x=>x.flightNo.includes(this.searchKey.toUpperCase()) || x.route.includes(this.searchKey.toUpperCase()));
   let filterResults=this.flightPassenger.filter(x=>x.flightNo.includes(this.searchKey.toUpperCase()) || x.operatorCode.includes(this.searchKey.toUpperCase())  || x.route.includes(this.searchKey.toUpperCase()) || x.flightOrders.some(y=>y.fullName.toLocaleLowerCase().includes(this.searchKey) || y.fullName.toUpperCase().includes(this.searchKey)  || y.agency.name.toUpperCase().includes(this.searchKey)  || y.agency.name.toLocaleLowerCase().includes(this.searchKey)));
    
   
   this.flightPassenger= filterResults;
    }
    else{
      this.flightPassenger=this.filterPassengerList;
      let filterResults=this.flightPassenger.filter(x=>x.flightNo.includes(this.searchKey.toUpperCase()) || x.operatorCode.includes(this.searchKey.toUpperCase()) || x.route.includes(this.searchKey.toUpperCase()) || x.flightOrders.some(y=>y.fullName.toLocaleLowerCase().includes(this.searchKey)  || y.fullName.toUpperCase().includes(this.searchKey )|| y.agency.name.toUpperCase().includes(this.searchKey)  || y.agency.name.toLocaleLowerCase().includes(this.searchKey)));
    this.flightPassenger= filterResults;
    }
 
   
    
  }
  async getAgency() {
    await this.$store.dispatch({
      type: "agency/getAgency",
    });
    this.agencies = this.$store.state.agency.list;
  }
}
